module.exports = __webpack_public_path__ + "prod/1.42.2/img/bannerForm1.9be36c64.png";